import Image from "next/image";
import React from "react";

interface MeetYourCouchFrameProps {
  photoUrl?: string;
  backgroundSvg?: React.ReactNode;
  width?: number;
  height?: number;
  svgClass?: string;
  x?:string;
  y?:string;
}

const MeetYourCouchFrame: React.FC<MeetYourCouchFrameProps> = ({
  photoUrl = "/krish-kp/teacher.webp",
  backgroundSvg,
  width = 570,
  height = 572,
  svgClass,
  x="15",y="30"
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
      className={`${svgClass} p-10 max-sm:p-0 relative`}
    >
      {/* Background SVG (fallback to a gradient if none provided) */}
      <svg
        width="570"
        height="572"
        viewBox="0 0 570 572"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className=""
      >
        <mask
          id="mask0_87_119"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="570"
          height="572"
        >
          <path d="M0.117798 0H569.806V571.01H0.117798V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_87_119)">
          <mask
            id="mask1_87_119"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="570"
            height="571"
          >
            <path
              d="M569.806 285.388L565.786 289.408C565.194 290 564.602 290.592 564.127 291.184C555.962 300.657 550.399 314.384 545.078 327.761C534.304 354.396 522.236 384.219 486.734 384.219H486.259C495.731 423.046 490.761 453.468 471.822 472.282C452.89 491.221 422.593 496.075 383.779 486.726C384.013 522.593 354.073 534.785 327.328 545.552C313.959 550.997 300.231 556.56 290.766 564.732C290.056 565.324 289.464 565.792 288.989 566.384L285.086 570.528L281.059 566.625C280.467 566.033 279.875 565.441 279.283 564.966C269.817 556.801 256.089 551.238 242.72 545.91C215.975 535.136 186.035 522.944 186.269 487.084C147.455 496.55 117.041 491.579 98.2258 472.64C79.2871 453.702 74.4406 423.404 83.7894 384.577H83.3144C47.8121 384.577 35.744 354.747 24.9701 328.119C19.5315 314.742 13.969 301.008 5.80422 291.542C5.21217 290.833 4.73715 290.241 4.14511 289.766L0.117798 285.505L4.02807 281.478C4.62012 280.886 5.21217 280.293 5.6803 279.708C13.8451 270.236 19.4076 256.508 24.736 243.132C35.503 216.497 47.5781 186.667 83.0734 186.667H83.5485C74.0826 147.847 79.053 117.425 97.9848 98.6034C116.923 79.6647 147.214 74.8113 186.035 84.1671C185.794 48.2999 215.734 36.1079 242.479 25.334C255.855 19.8954 269.583 14.326 279.048 6.16123C279.758 5.56918 280.35 5.09416 280.825 4.50211L284.845 0.481689L288.872 4.50211C289.464 5.09416 290.056 5.68621 290.648 6.16123C300.114 14.326 313.842 19.8954 327.211 25.2169C353.956 35.9908 383.896 48.1829 383.662 84.0432C422.476 74.5773 452.89 79.5477 471.705 98.4864C490.637 117.425 495.49 147.73 486.142 186.55H486.617C522.119 186.55 534.187 216.38 544.961 243.008C550.399 256.384 555.962 270.119 564.127 279.584C564.719 280.293 565.194 280.886 565.786 281.361L569.806 285.388Z"
              fill="white"
            />
          </mask>
          
          <g mask="url(#mask1_87_119)">
            <path
              d="M0.117798 0.481689V570.528H569.806V0.481689H0.117798Z"
              fill="url(#paint1_radial_87_119)"
            />
          </g>
        </g>
        <mask
          id="mask2_87_119"
          maskUnits="userSpaceOnUse"
          x="22"
          y="22"
          width="526"
          height="527"
        >
          <path
            d="M22.4364 22.9109H547.625V548.099H22.4364V22.9109Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_87_119)">
          <mask
            id="mask3_87_119"
            maskUnits="userSpaceOnUse"
            x="23"
            y="24"
            width="524"
            height="523"
          >
            <path
              d="M546.262 285.505C538.806 296.279 533.595 308.939 528.624 321.248C517.265 349.302 509.217 366.464 486.85 366.464C484.84 366.464 482.589 366.347 480.345 365.996L462.122 363.745L467.093 381.383C477.15 416.892 474.424 444.704 459.279 459.739C450.164 468.854 436.678 473.467 419.164 473.467C407.681 473.467 394.787 471.457 380.819 467.553L363.188 462.583L365.439 480.805C368.868 508.15 351.471 516.555 320.588 529.099C308.279 534.076 295.612 539.164 284.845 546.736C274.195 539.164 261.418 534.076 249.109 529.099C218.219 516.555 200.946 508.15 204.257 480.805L206.509 462.583L188.871 467.553C174.91 471.457 162.009 473.467 150.532 473.467C133.019 473.467 119.526 468.854 110.411 459.739C95.7404 444.704 93.0142 416.892 103.079 381.383L108.049 363.745L89.8199 365.996C87.5756 366.23 85.3244 366.464 83.3142 366.464C60.9472 366.464 52.8995 349.302 41.5404 321.248C36.5699 308.939 31.4824 296.279 23.9097 285.505C31.3654 274.855 36.5699 262.071 41.5404 249.762C52.8995 221.708 60.9472 204.546 83.3142 204.546C85.3244 204.546 87.5756 204.663 89.8199 205.014L108.049 207.265L103.079 189.628C93.0142 154.118 95.7404 126.306 110.886 111.271C120.001 102.156 133.487 97.5434 150.884 97.5434C162.367 97.5434 175.261 99.5536 189.229 103.457L206.86 108.427L204.608 90.2047C201.18 62.8604 218.577 54.4546 249.46 41.9115C261.769 36.9341 274.436 31.8466 285.203 24.2739C295.853 31.8466 308.63 36.9341 320.939 41.9115C351.829 54.4546 369.102 62.8604 365.79 90.2047L363.539 108.427L381.177 103.457C395.138 99.5536 408.039 97.5434 419.515 97.5434C437.029 97.5434 450.522 102.156 459.637 111.271C474.665 126.306 477.502 154.235 467.444 189.628L462.473 207.265L480.696 205.014C482.947 204.78 485.198 204.546 487.208 204.546C509.575 204.546 517.623 221.708 528.982 249.762C533.595 262.071 538.682 274.855 546.262 285.505Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask3_87_119)">
            <path
              d="M23.9097 546.736V24.2739H546.262V546.736H23.9097Z"
              fill="url(#paint1_radial_87_119)"
            />
          </g>
        </g>
        <defs>
          <radialGradient
            id="paint1_radial_87_119"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(285.083 285.505) scale(261.176 261.233)"
          >
            <stop stopColor="#883249" />
            <stop offset="0.0625" stopColor="#873148" />
            <stop offset="0.121094" stopColor="#863148" />
            <stop offset="0.175781" stopColor="#863147" />
            <stop offset="0.226562" stopColor="#853047" />
            <stop offset="0.273438" stopColor="#853047" />
            <stop offset="0.292969" stopColor="#842F46" />
            <stop offset="0.3125" stopColor="#832F45" />
            <stop offset="0.332031" stopColor="#822E44" />
            <stop offset="0.351562" stopColor="#812D44" />
            <stop offset="0.371094" stopColor="#812D43" />
            <stop offset="0.390625" stopColor="#802C42" />
            <stop offset="0.40625" stopColor="#7F2B42" />
            <stop offset="0.421875" stopColor="#7E2B41" />
            <stop offset="0.4375" stopColor="#7E2A40" />
            <stop offset="0.453125" stopColor="#7D2A40" />
            <stop offset="0.46875" stopColor="#7C293F" />
            <stop offset="0.484375" stopColor="#7B293F" />
            <stop offset="0.492188" stopColor="#7B283E" />
            <stop offset="0.5" stopColor="#7A283D" />
            <stop offset="0.507812" stopColor="#7A273D" />
            <stop offset="0.511719" stopColor="#79273D" />
            <stop offset="0.515625" stopColor="#79273C" />
            <stop offset="0.519531" stopColor="#79273C" />
            <stop offset="0.523438" stopColor="#78263C" />
            <stop offset="0.527344" stopColor="#78263C" />
            <stop offset="0.53125" stopColor="#78263B" />
            <stop offset="0.535156" stopColor="#77263B" />
            <stop offset="0.539062" stopColor="#77263B" />
            <stop offset="0.542969" stopColor="#76253B" />
            <stop offset="0.546875" stopColor="#76253A" />
            <stop offset="0.550781" stopColor="#76253A" />
            <stop offset="0.554688" stopColor="#75253A" />
            <stop offset="0.558594" stopColor="#752439" />
            <stop offset="0.5625" stopColor="#752439" />
            <stop offset="0.566406" stopColor="#742439" />
            <stop offset="0.570312" stopColor="#742439" />
            <stop offset="0.574219" stopColor="#742338" />
            <stop offset="0.578125" stopColor="#732338" />
            <stop offset="0.582031" stopColor="#732338" />
            <stop offset="0.585938" stopColor="#732337" />
            <stop offset="0.589844" stopColor="#722237" />
            <stop offset="0.59375" stopColor="#722237" />
            <stop offset="0.597656" stopColor="#722237" />
            <stop offset="0.601562" stopColor="#712236" />
            <stop offset="0.605469" stopColor="#712136" />
            <stop offset="0.609375" stopColor="#712136" />
            <stop offset="0.613281" stopColor="#702135" />
            <stop offset="0.617188" stopColor="#702135" />
            <stop offset="0.621094" stopColor="#702135" />
            <stop offset="0.625" stopColor="#6F2035" />
            <stop offset="0.628906" stopColor="#6F2034" />
            <stop offset="0.636719" stopColor="#6E1F34" />
            <stop offset="0.644531" stopColor="#6D1F33" />
            <stop offset="0.652344" stopColor="#6D1E32" />
            <stop offset="0.660156" stopColor="#6C1E32" />
            <stop offset="0.667969" stopColor="#6B1D31" />
            <stop offset="0.671875" stopColor="#6B1D31" />
            <stop offset="0.675781" stopColor="#6A1D30" />
            <stop offset="0.679688" stopColor="#6A1C30" />
            <stop offset="0.683594" stopColor="#691C30" />
            <stop offset="0.6875" stopColor="#681C2F" />
            <stop offset="0.691406" stopColor="#681B2F" />
            <stop offset="0.695312" stopColor="#671B2E" />
            <stop offset="0.699219" stopColor="#671A2E" />
            <stop offset="0.703125" stopColor="#661A2D" />
            <stop offset="0.707031" stopColor="#661A2D" />
            <stop offset="0.710938" stopColor="#65192D" />
            <stop offset="0.714844" stopColor="#65192C" />
            <stop offset="0.71875" stopColor="#64192C" />
            <stop offset="0.722656" stopColor="#64182B" />
            <stop offset="0.726562" stopColor="#63182B" />
            <stop offset="0.730469" stopColor="#62172A" />
            <stop offset="0.734375" stopColor="#62172A" />
            <stop offset="0.738281" stopColor="#61172A" />
            <stop offset="0.742188" stopColor="#611629" />
            <stop offset="0.746094" stopColor="#601629" />
            <stop offset="0.75" stopColor="#601528" />
            <stop offset="0.753906" stopColor="#5F1528" />
            <stop offset="0.757812" stopColor="#5F1527" />
            <stop offset="0.761719" stopColor="#5E1427" />
            <stop offset="0.765625" stopColor="#5D1427" />
            <stop offset="0.769531" stopColor="#5D1426" />
            <stop offset="0.773438" stopColor="#5C1326" />
            <stop offset="0.777344" stopColor="#5C1325" />
            <stop offset="0.78125" stopColor="#5B1225" />
            <stop offset="0.785156" stopColor="#5B1224" />
            <stop offset="0.789062" stopColor="#5A1224" />
            <stop offset="0.792969" stopColor="#5A1124" />
            <stop offset="0.796875" stopColor="#591123" />
            <stop offset="0.800781" stopColor="#591123" />
            <stop offset="0.804688" stopColor="#581022" />
            <stop offset="0.808594" stopColor="#571022" />
            <stop offset="0.8125" stopColor="#570F21" />
            <stop offset="0.816406" stopColor="#560F21" />
            <stop offset="0.820312" stopColor="#560F21" />
            <stop offset="0.824219" stopColor="#550E20" />
            <stop offset="0.828125" stopColor="#550E20" />
            <stop offset="0.832031" stopColor="#540D1F" />
            <stop offset="0.835938" stopColor="#530D1F" />
            <stop offset="0.839844" stopColor="#530C1E" />
            <stop offset="0.84375" stopColor="#520C1D" />
            <stop offset="0.847656" stopColor="#510B1D" />
            <stop offset="0.851562" stopColor="#510B1C" />
            <stop offset="0.855469" stopColor="#500A1C" />
            <stop offset="0.859375" stopColor="#4F0A1B" />
            <stop offset="0.863281" stopColor="#4F091B" />
            <stop offset="0.867188" stopColor="#4E091A" />
            <stop offset="0.871094" stopColor="#4D081A" />
            <stop offset="0.875" stopColor="#4D0819" />
            <stop offset="0.878906" stopColor="#4C0718" />
            <stop offset="0.882812" stopColor="#4B0718" />
            <stop offset="0.886719" stopColor="#4B0617" />
            <stop offset="0.890625" stopColor="#4A0617" />
            <stop offset="0.894531" stopColor="#490516" />
            <stop offset="0.898438" stopColor="#490516" />
            <stop offset="0.902344" stopColor="#480415" />
            <stop offset="0.90625" stopColor="#470414" />
            <stop offset="0.910156" stopColor="#470314" />
            <stop offset="0.914062" stopColor="#460313" />
            <stop offset="0.917969" stopColor="#450213" />
            <stop offset="0.921875" stopColor="#450212" />
            <stop offset="0.925781" stopColor="#440112" />
            <stop offset="0.929688" stopColor="#430111" />
            <stop offset="0.933594" stopColor="#430010" />
            <stop offset="1" stopColor="#420010" />
          </radialGradient>
        </defs>
      </svg>

      {/* Define the clipping path for the frame */}
      <defs>
        <clipPath id="frameClip" className="">
          <path d="M284.968 570.528L280.941 566.625C280.349 566.033 279.757 565.441 279.165 564.966C269.699 556.801 255.972 551.238 242.602 545.91C215.857 535.136 185.917 522.944 186.151 487.084C147.338 496.55 116.923 491.579 98.108 472.64C79.1693 453.702 74.3228 423.404 83.6716 384.577C83.5477 384.577 83.3136 384.577 83.1966 384.577C47.6943 384.577 35.6262 354.747 24.8523 328.119C19.4137 314.742 13.8512 301.008 5.68642 291.542C5.09437 290.833 4.61936 290.241 4.02731 289.766L0 285.505L3.91027 281.478C4.50232 280.886 5.09437 280.293 5.5625 279.708C13.7273 270.236 19.2898 256.508 24.6182 243.132C35.3852 216.497 47.4603 186.667 82.9557 186.667C83.0796 186.667 83.3136 186.667 83.4307 186.667C73.9648 147.847 78.9352 117.425 97.867 98.6034C116.806 79.6647 147.097 74.8113 185.917 84.1671C185.676 48.2999 215.616 36.1079 242.361 25.334C255.737 19.8954 269.465 14.326 278.931 6.16123C279.64 5.56918 280.232 5.09416 280.707 4.50211L284.727 0.481689L288.755 4.50211C289.347 5.09416 289.939 5.68621 290.531 6.16123C299.997 14.326 313.724 19.8954 327.093 25.2169C353.839 35.9908 383.778 48.1829 383.544 84.0432C422.358 74.5773 452.773 79.5477 471.587 98.4864C490.519 117.425 495.373 147.73 486.024 186.55C486.141 186.55 486.382 186.55 486.499 186.55C522.001 186.55 534.069 216.38 544.843 243.008C550.282 256.384 555.844 270.119 564.009 279.584C564.601 280.293 565.076 280.886 565.668 281.361L569.688 285.388L565.668 289.408C565.076 290 564.484 290.592 564.009 291.184C555.844 300.657 550.282 314.384 544.96 327.761C534.186 354.396 522.118 384.219 486.616 384.219C486.499 384.219 486.265 384.219 486.141 384.219C495.614 423.046 490.643 453.468 471.704 472.289C452.773 491.221 422.475 496.075 383.661 486.726C383.895 522.593 353.956 534.785 327.21 545.552C313.841 550.997 300.114 556.56 290.648 564.732C289.939 565.324 289.347 565.792 288.872 566.384L284.968 570.528Z" />
        </clipPath>
      </defs>

      <svg width="570" height="572" viewBox="0 0 570 572">
        <image
          xlinkHref={photoUrl}
          x={x}
          y={y}
          width="550"
          height="552"
          clipPath="url(#frameClip)"
          preserveAspectRatio="xMidYMid slice"
          className=""
        />
      </svg>

      {/* Frame outline with gradient */}

      <path
        d="M284.968 570.528L280.941 566.625C280.349 566.033 279.757 565.441 279.165 564.966C269.699 556.801 255.972 551.238 242.602 545.91C215.857 535.136 185.917 522.944 186.151 487.084C147.338 496.55 116.923 491.579 98.108 472.64C79.1693 453.702 74.3228 423.404 83.6716 384.577C83.5477 384.577 83.3136 384.577 83.1966 384.577C47.6943 384.577 35.6262 354.747 24.8523 328.119C19.4137 314.742 13.8512 301.008 5.68642 291.542C5.09437 290.833 4.61936 290.241 4.02731 289.766L0 285.505L3.91027 281.478C4.50232 280.886 5.09437 280.293 5.5625 279.708C13.7273 270.236 19.2898 256.508 24.6182 243.132C35.3852 216.497 47.4603 186.667 82.9557 186.667C83.0796 186.667 83.3136 186.667 83.4307 186.667C73.9648 147.847 78.9352 117.425 97.867 98.6034C116.806 79.6647 147.097 74.8113 185.917 84.1671C185.676 48.2999 215.616 36.1079 242.361 25.334C255.737 19.8954 269.465 14.326 278.931 6.16123C279.64 5.56918 280.232 5.09416 280.707 4.50211L284.727 0.481689L288.755 4.50211C289.347 5.09416 289.939 5.68621 290.531 6.16123C299.997 14.326 313.724 19.8954 327.093 25.2169C353.839 35.9908 383.778 48.1829 383.544 84.0432C422.358 74.5773 452.773 79.5477 471.587 98.4864C490.519 117.425 495.373 147.73 486.024 186.55C486.141 186.55 486.382 186.55 486.499 186.55C522.001 186.55 534.069 216.38 544.843 243.008C550.282 256.384 555.844 270.119 564.009 279.584C564.601 280.293 565.076 280.886 565.668 281.361L569.688 285.388L565.668 289.408C565.076 290 564.484 290.592 564.009 291.184C555.844 300.657 550.282 314.384 544.96 327.761C534.186 354.396 522.118 384.219 486.616 384.219C486.499 384.219 486.265 384.219 486.141 384.219C495.614 423.046 490.643 453.468 471.704 472.289C452.773 491.221 422.475 496.075 383.661 486.726C383.895 522.593 353.956 534.785 327.21 545.552C313.841 550.997 300.114 556.56 290.648 564.732C289.939 565.324 289.347 565.792 288.872 566.384L284.968 570.528Z"
        fill="none"
        stroke="url(#frameGradient)"
        strokeWidth="12"
        className=""
      />

      {/* Gradient for the frame outline */}
      <defs>
        <linearGradient
          id="frameGradient"
          x1="285.084"
          y1="9.71327"
          x2="285.084"
          y2="561.297"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB045" />
          <stop offset="0.5" stopColor="#F7D558" />
          <stop offset="1" stopColor="#D68639" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export { MeetYourCouchFrame };
